<template>
  <div class="body">
    <XjdTop :isfixed="false"></XjdTop>
    <div class="page">
      <div class="pageOne">
        <div class="uimg" @click="gozhsz">
          <img :src="userinfo.avatar" alt="" srcset="">
        </div>
        <div class="uflex_r">
          <div class="texts">
            <div class="t1">{{ userinfo.nickname }}</div>
            <div class="t2">账号：{{ userinfo.username }}</div>
            <div class="t2">IP属地：{{ userinfo.city }}</div>
          </div>
          <div class="wuflex">
            <div class="wflex">
              支持物流：
              <div class="items" v-for="(item, index) in userinfo.logistics_datas" :key="index">
                <div v-if="index < 10" style="margin-right: 6px;">{{ item.name }}</div>
              </div>
              <div class="btn" @click="popup.ischeckpop = true">查看全部</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page1">
      <div class="pageTwo">
        <!-- 导航区 -->
        <div class="mine">
          <div class="mine_item" @click="changeMenu(item, index)" :class="nowIndex == index ? 'active' : ''"
            v-for="(item, index) in menulist" :key="index">
            <el-badge v-if="index == 4 && xiaonum != 0" :value="xiaonum" :max="99" class="item">
              {{ item.menuname }}
            </el-badge>
            <span v-else>{{ item.menuname }}</span>
          </div>
        </div>
        <div class="mine_r">
          <router-view></router-view>
        </div>
      </div>
    </div>
    <div class="page_right" v-if="true">
      <div class="right_1">
        <div class="item" @click="openTim1()">
          <el-badge :value="xiaonum" :hidden="xiaonum == 0 ? true : false" :max="99">
            <div>
              <img src="@/assets/imgleft/i2.png" alt="" srcset="">
            </div>
            <div class="text">消息</div>
          </el-badge>
        </div>
        <div class="x"></div>
        <div class="item" @click="openkf()">
          <el-badge :value="kfxiaonum" :hidden="kfxiaonum == 0 ? true : false" :max="99">
            <div>
              <img src="@/assets/imgleft/i3.png" alt="" srcset="">
            </div>
            <div class="text">售后客服</div>
          </el-badge>

        </div>
        <div class="x"></div>
        <div class="item" @click="goindex">
          <div>
            <img src="@/assets/imgleft/i5.png" alt="" srcset="">
          </div>
          <div class="text">返回 首页</div>
        </div>
      </div>
      <div class="jb">
        <div class="text1">
          到货后请及时验收，如有质量问题，请联系售后客服。
        </div>
      </div>

    </div>
    <el-dialog class="dialogs" :visible.sync="showTim" width="1122px">
      <TimView v-if="showTim" :openNum="openNum" :chatID="chatID"></TimView>
    </el-dialog>
    <el-dialog title="物流信息" width="620px" class="icon-dialog" :visible.sync="popup.ischeckpop" append-to-body
      @close="close">
      <div class="dialogs check">
        <div class="items" v-for="(item, index) in userinfo.logistics_datas" :key="index">
          {{ item.name }}
        </div>
      </div>
    </el-dialog>
    <Xjdbottom></Xjdbottom>
  </div>
</template>

<script>
import XjdTop from '@/components/XjdTop'
import Xjdbottom from '@/components/Xjdbottom'
import TimView from '@/components/TimView/index.vue'
import { mapState } from 'vuex'
export default {
  components: {
    XjdTop, Xjdbottom, TimView
  },
  name: '',
  data() {
    return {
      menulist: [
        {
          menuname: '交易订单',
          menuPath: '/jydd',
          index: 0
        },
        {
          menuname: '退款管理',
          menuPath: '/tkgl',
          index: 1

        },
        {
          menuname: '账号设置',
          menuPath: '/zhsz',
          index: 2

        },
        {
          menuname: '收货信息',
          menuPath: '/shxx',
          index: 3
        },
        {
          menuname: '消息通知',
          menuPath: '',
          index: 4
        },

      ],
      menuindex: 0,
      showTim: false,
      openNum: 0,
      popup: {
        ischeckpop: false
      },
      chatID: 1
    }
  },
  computed: {
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    ...mapState(['userinfo', 'nowIndex', 'xiaonum', 'kfxiaonum'])
  },
  mounted() {

  },
  methods: {
    openTim1() {
      if (this.isMobile) {
        this.$router.push({ path: "/mobile" })
        return
      }
      this.openNum = 2
      this.showTim = true
    },
    openkf() {
      if (this.isMobile) {
        this.$dataConver.gopage('1')
        return
      }
      this.openNum = 1
      this.chatID = 1
      this.showTim = true
    },
    close() {
      this.popup.ischeckpop = false
    },
    //返回首页
    goindex() {
      this.$router.push({ path: '/' }).catch(err => { })
    },
    gozhsz() {
      this.$store.commit('SetNowIndex', 2)
      this.$router.push({ path: '/zhsz' }).catch(err => { })
    },
    changeMenu(item, index) {
      if (this.isMobile && index == 4) {
        this.$router.push({ path: "/mobile" })
        return
      }
      if (index == 4) {
        this.showTim = true
        return
      }
      this.$store.commit('SetNowIndex', index)
      this.$router.push({ path: item.menuPath }).catch(err => { })
    }
  },
}
</script>
<style lang='scss' scoped>
.check {
  display: flex;
  flex-wrap: wrap;

  .items {
    margin-right: 20px;
    margin-bottom: 20px;
  }
}

.dialogs ::v-deep .el-dialog__body {
  padding: 12px 0px 0px 0px !important;
}

.dialogs ::v-deep .el-dialog__header {
  padding: 20px;
}

.page_right {
  position: fixed;
  left: 86%;
  top: 60%;
  transform: translate(-10%, -50%);

  .right_1 {
    width: 48px;
    background: #FFDB0C;
    border-radius: 6px 6px 6px 6px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    .x {
      width: 36px;
      height: 0px;
      border: 1px solid #000000;
      margin: 5px 0px;
    }

    .item {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #000000;
      line-height: 16px;
      padding: 16px 6px 10px 6px;
      cursor: pointer;

      img {
        width: 22px;
        height: 22px;
      }
    }
  }

  .gotop {
    width: 48px;
    cursor: pointer;
    margin-top: 20px;
    background: #FFDB0C;
    border-radius: 6px 6px 6px 6px;
    text-align: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #000000;
    line-height: 16px;
    padding: 10px;
    box-sizing: border-box;

    img {
      width: 22px;
      height: 22px;
    }
  }

  .jb {
    background: url('@/assets/imgleft/bcg2.png') no-repeat;
    width: 165px;
    height: 180px;
    margin-top: 20px;
    padding: 80px 12px 0px;
    box-sizing: border-box;

    .text1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #000000;
      line-height: 16px;
    }
  }
}

.page {
  width: 100%;
  height: 120px;
  background: #FFFFFF;
  border-radius: 0px 0px 0px 0px;
}

.pageOne {
  margin: 0 auto;
  max-width: 1200px;
  display: flex;
  height: 120px;
  align-items: center;

  .uimg {
    img {
      width: 80px;
      height: 80px;
      border-radius: 40px;
    }
  }

  .uflex_r {
    margin-left: 15px;

    .texts {
      display: flex;
      align-items: center;

      .t1 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #000000;
        line-height: 28px;
      }

      .t2 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #757575;
        line-height: 19px;
        margin-left: 46px;
      }
    }

    .wuflex {
      display: flex;
      margin-top: 10px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #E38111;
      line-height: 16px;

      .wflex {
        display: flex;
        align-items: center;
      }

      .btn {
        cursor: pointer;
        color: #298DF7;
      }

      .items:last-child span {
        display: none;
      }
    }
  }
}

.page1 {
  width: 100%;
  background: #F4F4F4;
  padding: 20px;
  box-sizing: border-box;
}

.pageTwo {
  margin: 0 auto;
  max-width: 1200px;
  display: flex;

  .mine {
    width: 140px;
    height: 730px;
    background: #FFFFFF;
    border-radius: 10px 10px 10px 10px;
    padding: 22px 10px;
    box-sizing: border-box;

    .mine_item {
      width: 120px;
      height: 46px;
      border-radius: 10px 10px 10px 10px;
      text-align: center;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #000000;
      line-height: 46px;
      margin-bottom: 6px;
      cursor: pointer;
    }

    .active {
      background-color: #FFDB0C;
    }
  }

  .mine_r {
    flex: 1;
    margin-left: 20px;
    background-color: #fff;
    border-radius: 10px;
  }
}
</style>